<app-accordion [isOpen]="props['isOpen'] || false" [headerText]="selectedLabel | translate">
  <div class="radio-list-options flex-responsive no-flex-grow p-md" [ngClass]="columnsClass">
    @for (option of $any(props.options) ?? []; track option.value) {
    <app-radio [name]="groupName" [value]="option.value"
      [(ngModel)]="selectedValue" (ngModelChange)="onSelectionChange($event)" [label]="option.label | translate"
      [attr.data-testid]="'radio-' + option.value" />
    }
  </div>
</app-accordion>